import React, { useEffect, useState } from "react";
import Head from "../../layout/head/Head";
import { useForm } from "react-hook-form";
import Content from "../../layout/content/Content";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  PreviewAltCard,
  Row,
} from "../../components/Component";
import { Badge, Form, Spinner } from "reactstrap";
import MyButton from "../../MyComp/UI/form/MyButton";
import Status from "../../MyComp/UI/form/Status";
import MyInput from "../../MyComp/UI/form/MyInput";
import { decrypt, ValidateImg } from "../../utils/Utils";
import MyDataTable from "../../MyComp/UI/DataTable/MyDataTable";
import ConfirmModal from "../../MyComp/UI/modals/ConfirmModal";
import { toast } from "react-toastify";
import useLogout from "../../hooks/useLogout";
import MyTextArea from "../../MyComp/UI/form/MyTextArea";
import MySelect from "../../MyComp/UI/form/MySelect";
import MyDate from "../../MyComp/UI/form/MyDate";
import moment from "moment";
import MyCreateSelect from "../../MyComp/UI/form/MyCreateSelect";
import ImageUpload from "../../MyComp/UI/form/ImageUpload";
import CKEditor from "../../MyComp/UI/CK Editor/index";
import MultiDropImage from "../../MyComp/UI/form/MultiDropImage";
import MyCheck from "../../MyComp/UI/form/MyCheck";
import {
  brandDDAPI,
  categoryDDAPI,
  ingredientsDDAPI,
  productTypeDDAPI,
  specializationDDAPI,
  unitDDAPI,
} from "../../api/dropdown";
import { BASE_URL_IMG } from "../../assets/constants";
import ViewImage from "../../MyComp/UI/modals/ViewImage";
import { listProductAPI } from "../../api/dropdown";
import { createProductAPI } from "../../api/dropdown";
import { updateProductAPI } from "../../api/dropdown";
import { diseaseDDAPI } from "../../api/dropdown";
const Product = () => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    setError,
    clearErrors,
    getValues,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: false,
      data: [],
      meta_image: null,
      meta_img: null,
      product_banner_img: null,
      product_banner_image: null,
      product_images: [],
      productTypeDD: [],
      brandsDD: [],
      categoryDD: [],
      unitDD: [],
      ingredientDD: [],
      diseaseDD: [],
      isPub: false,
      publish: false,
      fragile: false,
    },
  });
  const logout = useLogout();
  const [isOpen, setIsOpen] = useState(false);
  const [imageOpen, setImageOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [mode, setMode] = useState("Add");
  const isLoading = watch("isLoading");
  const [data, setData] = useState([]);
  const [column, setColumn] = useState([
    {
      name: "Name",
      selector: (row) => (
        <>
          <div className="tb-product" onClick={() => handleImageOpenPreview(`${BASE_URL_IMG}` + row?.meta_image)}>
            <img className="thumb" style={{ width: "50px" }} src={`${BASE_URL_IMG}` + row.meta_image} />

            <span className="title mx-2">{row?.product_name}</span>
          </div>
        </>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: "SKU",
      selector: (row) => row?.sku,
      sortable: true,
    },
    {
      name: "Stock",
      selector: (row) => row?.stock,
      sortable: true,
    },
    {
      name: "Price",
      selector: (row) => row?.mrp,
      sortable: true,
    },
    {
      name: "Expiry",
      selector: (row) => row?.expiry_date,
      sortable: true,
    },

    {
      name: "Status",
      selector: (row) => row?.status,
      cell: (row) => (
        <>
          <div style={{ cursor: "pointer" }} onClick={() => handleToggleStatus(row)}>
            <Badge color={`${row.status ? "success" : "danger"}`}>{row.status ? "Active" : "InActive"}</Badge>
          </div>
          <div style={{ cursor: "pointer" }}>
            <Button
              outline
              color={row?.publish ? `warning` : `success`}
              size={`xs`}
              className={`mx-1`}
              onClick={() => handleTogglePublish(row)}
              data-bs-toggle="tooltip"
              title={row?.publish ? "Achieve Product" : "Publish Product"}
            >
              <Icon name={row?.publish ? "inbox-in" : "inbox-out"}></Icon>
            </Button>{" "}
          </div>
        </>
      ),
      sortable: true,
      wrap: true,

      width: "220px",
    },
    {
      name: "Action",
      wrap: true,
      width: "220px",
      cell: (row) => (
        <div>
          <Button outline color={`warning`} size={`xs`} className={`me-1`} onClick={() => handleEdit(row)}>
            {" "}
            <Icon name="edit" />
          </Button>

          {/* <Button outline color={`danger`} size={`xs`} onClick={() => handleDelete(row)}>
               {" "}
               <Icon name="trash"></Icon>
             </Button> */}
        </div>
      ),
    },
  ]);
  const handleToggleStatus = (row) => {
    setValue("selectedRow", row);
    setShowModal(true);
  };
  const handleTogglePublish = (row) => {
    setValue("isPub", true);
    setValue("selectedRow", row);
    setShowModal(true);
  };
  const handleImageClose = () => {
    setImageOpen(!imageOpen);
  };
  useEffect(() => {
    getProductType();
    getBrands();
    getUnit();
    getCategory();
    getIngredient();
    getDisease();

    getProductList();
  }, []);
  const getProductList = () => {
    listProductAPI()
      .then((res) => {
        console.log("response list product", res);
        //const status = decrypt(res.data.status);
        if (res.data.status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        } else if (res.data.status === true) {
          toast.success(res.data.message);
          toast.clearWaitingQueue();
          setData(res.data.data);
          resetForm();
          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setData([]);
          toast.error(!res.data.message);
          toast.clearWaitingQueue();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  const getProductType = () => {
    productTypeDDAPI()
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          toast.success(res.data.message);
          toast.clearWaitingQueue();
          setValue("productTypeDD", res.data.data);
          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setValue("productTypeDD", []);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          console.log("token expired", res.data);
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  const getBrands = () => {
    brandDDAPI()
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          toast.success(res.data.message);
          toast.clearWaitingQueue();
          setValue("brandsDD", res.data.data);
          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setValue("brandsDD", []);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          console.log("token expired", res.data);
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };

  const getCategory = () => {
    categoryDDAPI()
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          toast.success(res.data.message);
          toast.clearWaitingQueue();
          setValue("categoryDD", res.data.data);
          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setValue("categoryDD", []);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          console.log("token expired", res.data);
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  const getUnit = () => {
    unitDDAPI()
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          toast.success(res.data.message);
          toast.clearWaitingQueue();
          setValue("unitDD", res.data.data);
          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setValue("unitDD", []);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          console.log("token expired", res.data);
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  const getDisease = () => {
    diseaseDDAPI()
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          toast.success(res.data.message);
          toast.clearWaitingQueue();
          setValue("diseaseDD", res.data.data);
          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setValue("diseaseDD", []);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          console.log("token expired", res.data);
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  const getIngredient = () => {
    ingredientsDDAPI()
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          toast.success(res.data.message);
          toast.clearWaitingQueue();
          setValue("ingredientDD", res.data.data);
          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setValue("ingredientDD", []);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          console.log("token expired", res.data);
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };

  const handleImageOpenPreview = (row, name) => {
    setImageOpen(!imageOpen);
    setValue("image_preview", row);
    trigger("image_preview");
  };
  const resetForm = () => {
    setMode("Add");
    setValue("sku", "");
    setValue("batch_no", "");
    setValue("manufacturer", "");
    setValue("mrp", "");
    setValue("gst", "");
    setValue("hsn", "");
    setValue("ayu_cash", "");
    setValue("exp_date", null);
    setValue("mfg_date", null);
    setValue("offer_price", "");
    setValue("fragile", "");
    setValue("publish", "");
    setValue("stock", "");
    setValue("min_purchase_qty", "");
    setValue("max_purchase_qty", "");
    setValue("low_stock_alert", "");
    setValue("product_name", "");
    setValue("category", "");
    setValue("disease", "");
    setValue("ingredients", "");
    setValue("brand", "");
    setValue("unit", "");
    setValue("product_type", "");
    setValue("short_description", "");
    setValue("long_description", "");
    setValue("meta_image", null);
    setValue("product_banner_image", null);
    setValue("status", "");
    setValue("meta_tags", "");
    setValue("product_images", null);
    setValue("isPub", false);
  };
  const handleEdit = (row) => {
    window.scrollTo(0, 0);
    setValue("selectedRow", row);
    setIsOpen(true);
    setMode("Edit");
    setValue("sku", row?.sku);
    setValue("batch_no", row?.batch_no);
    setValue("manufacturer", row?.manufacturer);
    setValue("mrp", row?.mrp);
    setValue("gst", row?.gst);
    setValue("hsn", row?.hsn);
    setValue("ayu_cash", row?.ayu_cash);
    const parseDate = (value) => {
      if (!value || value === "null") return undefined;

      const m = moment(value, ["YYYY-MM-DD", "DD/MM/YYYY"], true);
      return m.isValid() ? m.toDate() : undefined;
    };

    setValue("exp_date", parseDate(row?.expiry_date));
    setValue("mfg_date", parseDate(row?.manufacture_date));

    setValue("offer_price", row?.offer_price);
    setValue("fragile", row?.isFragile || false);
    setValue("publish", row?.isPublish || false);
    setValue("stock", row?.stock);
    setValue("min_purchase_qty", row?.min_purchase_qty);
    setValue("max_purchase_qty", row?.max_purchase_qty);
    setValue("low_stock_alert", row?.low_stock);
    setValue("product_name", row?.product_name);
    setValue("generic_name", row?.generic_name);
    setValue("category", row?.category);
    setValue("disease", row?.disease);
    setValue("ingredients", row?.ingredient);
    setValue("brand", row?.brand);
    setValue("unit", row?.unit);
    setValue("product_type", row?.product_types);
    setValue("short_description", row?.short_description);
    setValue("long_description", row?.long_description);
    setValue("meta_image", BASE_URL_IMG + row?.meta_image);
    setValue("product_banner_image", BASE_URL_IMG + row?.product_banner_image);
    setValue("status", row?.status ? { label: "Active", value: true } : { label: "InActive", value: false });
    if (row?.salt) {
      const tagArray = row.salt.split(",").map((tag) => {
        const trimmed = tag.trim();
        return {
          label: trimmed,
          value: trimmed,
        };
      });

      setValue("salt", tagArray);
    }
    if (row?.product_gallery?.length > 0) {
      const images = row.product_gallery.map((item) => ({
        preview: BASE_URL_IMG + item?.image,
        file: null,
      }));

      setValue("product_images", images);
    }
    setTimeout(() => {
      if (window?.CKEDITOR?.instances?.extra_product_details) {
        window.CKEDITOR.instances.extra_product_details.setData(row?.extra_product_details || ""); // Set existing content
      }
    }, 500);
  };
  const onFormSubmit = (data) => {
    const formData = new FormData();
    // const extra_product_description = window?.CKEDITOR?.instances.extra_product_details?.getData();
    // const cleanedContent = extra_product_description.replace(/&nbsp;/g, " ");
    formData.append("product_name", watch("product_name"));
    formData.append("generic_name", watch("generic_name"));
    formData.append("mrp", watch("mrp"));
    formData.append("batch_no", watch("batch_no"));
    formData.append("manufacturer", watch("manufacturer"));
    formData.append("offer_price", watch("offer_price"));
    // formData.append("extra_product_description", cleanedContent);
    // formData.append("ayu_cash", watch("ayu_cash"));
    // formData.append("product_type", watch("product_type")?.value);
    // formData.append("brand", watch("brand")?.value);
    formData.append("category", watch("category")?.value);
    formData.append(
      "disease",
      watch("disease")?.map((item) => item.value)
    );
    formData.append("exp_date", moment(watch("exp_date")).format("YYYY-MM-DD"));
    formData.append("mfg_date", moment(watch("mfg_date")).format("YYYY-MM-DD"));
    formData.append("fragile", watch("fragile") || false);
    formData.append("gst", watch("gst"));
    formData.append("hsn", watch("hsn"));
    formData.append("sku", watch("sku"));
    formData.append("stock", watch("stock"));
    formData.append("publish", watch("publish") || false);
    formData.append("unit", watch("unit")?.value);
    formData.append("status", watch("status")?.value);
    formData.append("max_purchase_qty", watch("max_purchase_qty"));
    formData.append("min_purchase_qty", watch("min_purchase_qty"));
    formData.append("low_stock_alert", watch("low_stock_alert"));
    formData.append("long_description", watch("long_description"));
    // formData.append("short_description", watch("short_description"));
    // formData.append(
    //   "ingredients",
    //   watch("ingredients")?.map((item) => item.value)
    // );
    // formData.append(
    //   "meta_tags",
    //   watch("meta_tags")?.map((item) => item.value)
    // );
    formData.append(
      "salt",
      watch("salt")?.map((item) => item.value)
    );
    // formData.append("meta_img", watch("meta_img"));
    // formData.append("product_banner_img", watch("product_banner_img"));
    // const files = data.product_images;
    // if (files && files.length > 0) {
    //   files.forEach((file, index) => {
    //     // file is already a File object with path and preview
    //     formData.append("product_images", file); // or use `images[]` depending on backend
    //   });
    // }
    const metaImg = watch("meta_img");
    // const productBannerImg = watch("product_banner_img");

    if (metaImg instanceof File) {
      formData.append("meta_img", metaImg);
    } else if (typeof metaImg === "string") {
      formData.append("meta_img", metaImg);
    }
    // if (productBannerImg instanceof File) {
    //   formData.append("product_banner_img", productBannerImg);
    // } else if (typeof productBannerImg === "string") {
    //   formData.append("product_banner_img", productBannerImg);
    // }
    // const files = data.product_images;
    // if (files && files.length > 0) {
    //   files.forEach((item, index) => {
    //     if (item instanceof File) {
    //       formData.append("product_images", item);
    //     } else if (typeof item.preview === "string") {
    //       const fileName = item.preview.split("/").pop();
    //       formData.append("product_images", fileName);
    //     }
    //   });
    // }
    console.log("data", data);
    if (mode == "Edit") {
      formData.append("id", watch("selectedRow")?.id);
    }
    if (mode == "Add") {
      createProductAPI(formData)
        .then((res) => {
          //const status = decrypt(res.data.status);
          if (res.data.status === true) {
            toast.success(res.data.message);
            toast.clearWaitingQueue();
            setIsOpen(false);
            getProductList();
            setValue("isLoading", false);
            resetForm();
          } else if (res.data.status === false) {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (res.data.status === "expired") {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          setValue("isLoading", false);
          toast.error(err?.response?.data?.message);
        });
    }
    if (mode == "Edit") {
      updateProductAPI(formData)
        .then((res) => {
          //const status = decrypt(res.data.status);
          if (res.data.status === true) {
            toast.success(res.data.message);
            toast.clearWaitingQueue();
            setIsOpen(false);
            getProductList();
            setValue("isLoading", false);
            resetForm();
          } else if (res.data.status === false) {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (res.data.status === "expired") {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          setValue("isLoading", false);
          toast.error(err?.response?.data?.message);
        });
    }

    console.log("form data", data);
  };
  const op = [
    {
      id: "1",
      label: "Electronics",
      value: "electronics",
      children: [
        {
          id: "1-1",
          label: "Mobile Phones",
          value: "mobile",
          children: [
            {
              id: "1-1-1",
              label: "Smartphones",
              value: "smartphones",
              children: [
                {
                  id: "1-1-1-1",
                  label: "Android",
                  value: "android",
                  children: [
                    { id: "1-1-1-1-1", label: "Samsung", value: "samsung" },
                    { id: "1-1-1-1-2", label: "OnePlus", value: "oneplus" },
                  ],
                },
                {
                  id: "1-1-1-2",
                  label: "iOS",
                  value: "ios",
                  children: [{ id: "1-1-1-2-1", label: "iPhone", value: "iphone" }],
                },
              ],
            },
            {
              id: "1-1-2",
              label: "Feature Phones",
              value: "feature-phones",
            },
          ],
        },
      ],
    },
    {
      id: "2",
      label: "Electronics1",
      value: "electronics1",
      children: [
        {
          id: "2-1",
          label: "Mobile Phones1",
          value: "mobile1",
        },
      ],
    },
  ];
  const handleChange = (currentNode, selectedNodes) => {
    console.log("Selected nodes:", selectedNodes);
    const selectedIds = selectedNodes.map((node) => node.id);
    console.log("Selected IDs:", selectedIds);
  };
  const confirmStatusChange = (data) => {
    const formData = new FormData();
    const updatedStatus = watch("selectedRow").status === true ? false : true;
    const updatedPub = watch("selectedRow").publish === true ? false : true;
    if (watch("isPub")) {
      formData.append("publish", updatedPub);
    } else {
      formData.append("status", updatedStatus);
    }
    formData.append("id", watch("selectedRow")?.id);
    setValue("isLoading", true);
    updateProductAPI(formData)
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          toast.success(res.data.message);
          toast.clearWaitingQueue();
          getProductList();
          setIsOpen(false);
          setValue("isLoading", false);
          setShowModal(false);
          resetForm();
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  return (
    <>
      <Head title={"Product | Master"} />
      <Content>
        <BlockHead size={`sm`}>
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {"Manage Products"}
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="">
                <Button
                  color="primary"
                  outline
                  className={`  me-n1`}
                  onClick={() => {
                    setIsOpen((pre) => !pre);
                    resetForm();
                  }}
                >
                  <Icon name={isOpen ? "minus" : "plus"} />
                </Button>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          {isOpen && (
            <PreviewAltCard>
              <Form onSubmit={handleSubmit(onFormSubmit)}>
                <Row>
                  <Col md="6" className={``}>
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Product Name"}
                      name={"product_name"}
                      placeholder={"Enter product name"}
                      required
                      min={2}
                      max={50}
                    />
                  </Col>
                  <Col md="6" className={``}>
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Generic Name"}
                      name={"generic_name"}
                      placeholder={"Enter product generic name"}
                      required
                      min={2}
                      max={50}
                    />
                  </Col>
                  <Col md={2}>
                    <MyCheck
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Fragile"}
                      name={"fragile"}
                      placeholder={"Is Product Fragile"}
                    />
                  </Col>
                  <Col md={2}>
                    <MyCheck
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Publish"}
                      name={"publish"}
                      placeholder={"Is Product Ready to go live"}
                    />
                  </Col>

                  <Col md="2" className={``}>
                    <MySelect
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Category"}
                      name={"category"}
                      placeholder={"Select category"}
                      required
                      options={watch("categoryDD")}
                    />
                  </Col>
                  <Col md="2" className={``}>
                    <MySelect
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Size/Weight"}
                      name={"unit"}
                      placeholder={"Select size / weight"}
                      required
                      options={watch("unitDD")}
                    />
                  </Col>
                  <Col md="2" className={``}>
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"MRP"}
                      name={"mrp"}
                      placeholder={"Enter MRP"}
                      required
                      min={1}
                      pattern={/^[0-9]+$/}
                      patternMsg="Only numbers are allowed"
                      max={7}
                    />
                  </Col>
                  <Col md="2" className={``}>
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Offer Price"}
                      name={"offer_price"}
                      placeholder={"Enter offer price"}
                      required
                      min={1}
                      max={7}
                    />
                  </Col>

                  <Col md="2" className={``}>
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Stock"}
                      name={"stock"}
                      placeholder={"Enter available stock"}
                      required
                      min={1}
                      max={4}
                    />
                  </Col>
                  <Col md="2" className={``}>
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Low Stock Alert Qty"}
                      name={"low_stock_alert"}
                      placeholder={"Enter low stock alert qty"}
                      required
                      min={1}
                      max={2}
                    />
                  </Col>
                  <Col md="2" className={``}>
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Minimum purchase qty"}
                      name={"min_purchase_qty"}
                      placeholder={"Enter minimum purchase qty"}
                      required
                      min={1}
                      max={2}
                    />
                  </Col>
                  <Col md="2" className={``}>
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Maximum purchase qty"}
                      name={"max_purchase_qty"}
                      placeholder={"Enter maximum purchase qty"}
                      required
                      min={1}
                      max={2}
                    />
                  </Col>

                  <Col md="2" className={``}>
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"GST"}
                      name={"gst"}
                      placeholder={"Enter gst"}
                      required
                      min={1}
                      max={4}
                    />
                  </Col>
                  <Col md="2" className={``}>
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Manufacturer"}
                      name={"manufacturer"}
                      placeholder={"Enter manufacturer name"}
                      required
                      min={5}
                      max={50}
                    />
                  </Col>
                  <Col md="2" className={``}>
                    <MyDate
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Manufacturing Date"}
                      name={"mfg_date"}
                      placeholder={"Enter manufacturing date"}
                      required
                      max={new Date()}
                      min={moment().subtract(2, "years").toDate()}
                    />
                  </Col>
                  <Col md="2" className={``}>
                    <MyDate
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Expiry Date"}
                      name={"exp_date"}
                      placeholder={"Enter expiry date"}
                      required
                      min={moment().add(1, "days").toDate()}
                      max={moment().add(5, "years").toDate()}
                    />
                  </Col>
                  {/* <Col md="2" className={``}>
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"AYU Cash"}
                      name={"ayu_cash"}
                      placeholder={"Enter ayu cash"}
                      required
                      min={1}
                      max={7}
                    />
                  </Col> */}
                  <Col md="2" className={``}>
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Batch Number"}
                      name={"batch_no"}
                      placeholder={"Enter batch no"}
                      required
                      min={2}
                      max={50}
                    />
                  </Col>
                  <Col md="2" className={``}>
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"HSN"}
                      name={"hsn"}
                      placeholder={"Enter hns name"}
                      required
                      min={2}
                      max={50}
                    />
                  </Col>
                  <Col md="2" className={``}>
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"SKU"}
                      name={"sku"}
                      placeholder={"Enter sku name"}
                      required
                      min={2}
                      max={50}
                    />
                  </Col>
                  {/* <Col md="6" className={``}>
                    <MySelect
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Ingredients"}
                      name={"ingredients"}
                      placeholder={"Select ingredients"}
                      required
                      options={watch("ingredientDD")}
                      multi
                    />
                  </Col> */}

                  <Col md="6" className={``}>
                    <MySelect
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Disease"}
                      name={"disease"}
                      placeholder={"Select disease"}
                      required
                      options={watch("diseaseDD")}
                      multi
                    />
                  </Col>
                  {/* <Col md="6" className={``}>
                    <MyCreateSelect
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Meta Tags"}
                      name={"meta_tags"}
                      placeholder={"Create meta tags"}
                      required
                      multi
                    />
                  </Col> */}
                  <Col md="6" className={``}>
                    <MyCreateSelect
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Salt"}
                      name={"salt"}
                      placeholder={"Enter salt"}
                      required
                      multi
                    />
                  </Col>
                  <Col md="3">
                    <ImageUpload
                      id="meta_image"
                      watch={watch}
                      trigger={trigger}
                      setError={setError}
                      clearErrors={clearErrors}
                      label={"Meta Image"}
                      errors={errors}
                      register={register}
                      image={"meta_img"}
                      image_url={"meta_image"}
                      setValue={setValue}
                      handleImageOpenPreview={handleImageOpenPreview}
                      required
                      getValues={getValues}
                    />
                  </Col>
                  {/* <Col md={3}>
                  <ImageUpload
                    id="product_banner_image"
                    watch={watch}
                    trigger={trigger}
                    setError={setError}
                    clearErrors={clearErrors}
                    label={"Product Banner Image"}
                    errors={errors}
                    register={register}
                    image={"product_banner_img"}
                    image_url={"product_banner_image"}
                    setValue={setValue}
                    handleImageOpenPreview={handleImageOpenPreview}
                    required
                  />
                 </Col> */}
                  {/* <Col md={12}>
                    <MultiDropImage
                      name={"product_images"}
                      title={"Product Images"}
                      register={register}
                      setValue={setValue}
                      watch={watch}
                      trigger={trigger}
                      errors={errors}
                      fileType={[".jpg", ".png", ".svg"]}
                      maxSize={1024}
                      required
                    />
                  </Col> */}
                  {/* <Col md="12" className={``}>
                    <MyTextArea
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Short Description"}
                      name={"short_description"}
                      placeholder={"Enter short product description"}
                      required
                      min={25}
                      max={300}
                      cols={2}
                      row={2}
                    />
                  </Col> */}
                  <Col md="12" className={``}>
                    <MyTextArea
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Long Description"}
                      name={"long_description"}
                      placeholder={"Enter long product description"}
                      required
                      min={100}
                      max={500}
                      cols={2}
                      row={2}
                    />
                  </Col>
                  {/* <Col md={12}>
                    <CKEditor title={"Extra Product Details"} id="extra_product_details" />
                  </Col> */}

                  <Col md={`2`}>
                    <Status
                      register={register}
                      watch={watch}
                      title={"Status"}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                    />
                  </Col>
                </Row>
                <Col md="2" className={``}>
                  <div className="form-group" style={{ marginTop: "31px" }}>
                    <MyButton isLoading={isLoading} mode={mode} />
                  </div>
                </Col>
              </Form>
            </PreviewAltCard>
          )}
          <MyDataTable data={data || []} columns={column} title={"Product List"} isLoading={isLoading} />
        </Block>
      </Content>
      <ViewImage url={watch("image_preview")} imageOpen={imageOpen} handleImageClose={handleImageClose} />
      <ConfirmModal
        isOpen={showModal}
        toggle={() => {
          setShowModal(!showModal);
          setValue("isPub", false);
        }}
        onConfirm={confirmStatusChange}
        status={watch("selectedRow")?.status}
        isPub={watch("isPub")}
        data={watch("selectedRow")}
      />
    </>
  );
};

export default Product;
